import React from "react"
import {observer} from "mobx-react-lite"
import {GTMapboxComponent} from "@gtrnd/gt-map-lip"
import "@gtrnd/gt-map-lip/dist/index.css"
import config from "../../../config"

const MapContainer = ({
  geoObj,
  categoryId,
  brandId,
  handleGeoUpdate,
  visitDuration,
  stateDistribution,
  dmaDistribution,
  showLoader,
  locationGroupId,
  tenantId,
  authToken,
  mapPadding,
}) => {
  const mapTimePeriod = (days) => {
    const map = new Map([
      ["SEVEN_DAYS", "7D"],
      ["FOURTEEN_DAYS", "14D"],
      ["THIRTY_DAYS", "30D"],
      ["FORTY_FIVE_DAYS", "45D"],
      ["SIXTY_DAYS", "60D"],
      ["NINETY_DAYS", "90D"],
    ])
    let returnVal = map.get(days)
    return returnVal
  }

  const timePeriod = mapTimePeriod(visitDuration)

  const handleGeoSelection = (geo) => {
    handleGeoUpdate(geo, window.location.pathname)
  }
  return (
    <div id="map-container" data-testid="mapcontainer-test">
      <div className="map-section">
        <GTMapboxComponent
          geo={geoObj}
          categoryId={categoryId}
          brandId={brandId}
          onGeoSelection={handleGeoSelection}
          visitDuration={timePeriod}
          stateDistribution={stateDistribution}
          dmaDistribution={dmaDistribution}
          showLoader={showLoader}
          locationGroupId={locationGroupId}
          tenantId={tenantId}
          authToken={authToken}
          useProdConfig={config.mapProdConfig}
          mapPadding={mapPadding}
        />
      </div>
    </div>
  )
}
export default observer(MapContainer)
